import logo from "@/assets/logo.png";

export function Footer() {
  return (
    <footer className="border-t border-border/60 bg-surface">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <img src={logo} alt="Hummany" className="h-8 w-auto" />
            <p className="mt-4 max-w-sm text-sm text-muted-foreground">
              Acompañamiento emocional en tiempo real para equipos modernos.
            </p>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-foreground">Plataforma</h4>
            <ul className="mt-3 space-y-2 text-sm text-muted-foreground">
              <li><a href="#como-funciona" className="hover:text-foreground">Ver cómo funciona</a></li>
              <li><a href="#producto" className="hover:text-foreground">El producto</a></li>
              <li><a href="#privacidad" className="hover:text-foreground">Privacidad y datos</a></li>
              <li><a href="#cta" className="hover:text-foreground">Agenda una demo</a></li>
              <li><a href="#cta" className="hover:text-foreground">Contacto</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-foreground">Legal</h4>
            <ul className="mt-3 space-y-2 text-sm text-muted-foreground">
              <li><a href="/legal/terminos" target="_blank" rel="noopener noreferrer" className="hover:text-foreground">Términos y Condiciones</a></li>
              <li><a href="/legal/privacidad" target="_blank" rel="noopener noreferrer" className="hover:text-foreground">Política de Privacidad</a></li>
              <li><a href="/legal/cookies" target="_blank" rel="noopener noreferrer" className="hover:text-foreground">Política de Cookies</a></li>
              <li><a href="/legal/aviso-legal" target="_blank" rel="noopener noreferrer" className="hover:text-foreground">Aviso Legal</a></li>
            </ul>
          </div>
        </div>
        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-border/60 pt-6 text-xs text-muted-foreground sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} Hummany. Todos los derechos reservados.</p>
          <p>Hecho con cuidado para las personas en el trabajo.</p>
        </div>
      </div>
    </footer>
  );
}
